import { ARIValues, DailySet, ValueTypes } from "../../shared/types";
import { InventoryConfiguration } from "../../shared/domain/InventoryConfiguration";
import { AriType } from "../../updateForm";

export class Inventory implements ARIValues {
  ticker: string;
  name: string;
  parentTicker?: string;
  dailySet: DailySet[];
  valueType: ValueTypes;
  configuration: InventoryConfiguration;
  isChild: boolean;
  type: AriType;
  formula?: string;
  parametrizedFormula?: {
    immutableFormula?: string;
    rateOwner?: string;
  };

  private constructor(
    ticker: string,
    name: string,
    configuration: InventoryConfiguration,
    parentTicker: string | undefined,
    dailySet: DailySet[],
    valueType: ValueTypes,
    isChild: boolean,
    formula?: string,
    parametrizedFormula?: {
      immutableFormula?: string;
      rateOwner?: string;
    }
  ) {
    this.ticker = ticker;
    this.name = name;
    this.configuration = configuration;
    this.parentTicker = parentTicker;
    this.dailySet = dailySet;
    this.valueType = valueType;
    this.isChild = isChild;
    this.type = AriType.INVENTORY_LINES;
    this.formula = formula;
    this.parametrizedFormula = parametrizedFormula;
  }

  static of(
    ticker: string,
    name: string,
    configuration: InventoryConfiguration,
    parentTicker: string | undefined,
    dailySet: DailySet[] | undefined,
    type: ValueTypes,
    isChild: boolean,
    formula?: string,
    parametrizedFormula?: {
      immutableFormula?: string;
      rateOwner?: string;
    }
  ): Inventory {
    return new Inventory(
      ticker,
      name,
      configuration,
      parentTicker,
      dailySet || [],
      type,
      isChild,
      formula,
      parametrizedFormula
    );
  }
}
